<template>
    <div class="content">
        <div class="title">
            <Header @changeSite="changeSite" />
        </div>
        <div class="body" v-if="$store.getters.projectId == 4||$store.getters.projectId == 5">
            <Box width="1600" height="864" title="温湿度监测">
                <div class="box">
                    <div :style="'margin-top:' + 300/108 + 'vh;'">
                        <MonitorItem :icon="require('@/assets/img/温度.png')" title="实时温度"
                            :data="$store.getters.mqttVal(deviceName + '/' + 'Temperature') || '--'" unit="℃" />
                        <div class="smallChart" :style="'height:' + 2300/108 + 'vh;' + 'width:' + 15000/192 + 'vw'">
                            <SingalLine :dataArr="tData.length > 0 ? tData : []"
                                :axisArr="taxisArr.length > 0 ? taxisArr : []" />
                        </div>
                    </div>
                    <div :style="'margin-top:' + 300/108 + 'vh;'">
                        <MonitorItem :icon="require('@/assets/img/湿度.png')" title="实时湿度"
                            :data="$store.getters.mqttVal(deviceName + '/' + 'Humidity') || '--'" unit="%" />
                        <div class="smallChart" :style="'height:' + 2300/108 + 'vh;' + 'width:' + 15000/192 + 'vw'">
                            <SingalLine :dataArr="hData.length > 0 ? hData : []"
                                :axisArr="haxisArr.length > 0 ? haxisArr : []" />
                        </div>
                    </div>
                </div>
            </Box>
        </div>
        <div class="body" v-else>
            <div class="left">
                <Box width="1198" height="428" title="温湿度监测">
                    <div class="box">
                        <div class="itemContainer">
                            <MonitorItem :icon="require('@/assets/img/温度.png')" title="实时温度"
                                :data="$store.getters.mqttVal(deviceName + '/' + 'Temperature') || '--'" unit="℃" />
                            <div class="smallChart">
                                <SingalLine :dataArr="tData.length > 0 ? tData : []"
                                    :axisArr="taxisArr.length > 0 ? taxisArr : []" />
                            </div>
                        </div>
                        <div class="itemContainer" :style="'margin-left:' + 600/192 + 'vw'">
                            <MonitorItem :icon="require('@/assets/img/湿度.png')" title="实时湿度"
                                :data="$store.getters.mqttVal(deviceName + '/' + 'Humidity') || '--'" unit="%" />
                            <div class="smallChart">
                                <SingalLine :dataArr="hData.length > 0 ? hData : []"
                                    :axisArr="haxisArr.length > 0 ? haxisArr : []" />
                            </div>
                        </div>
                    </div>
                </Box>
                <Box width="1198" height="428" title="CO₂监测">
                    <div class="itemContainer">
                        <MonitorItem title="实时CO₂浓度" name="CO2" :icon="require('@/assets/img/CO2.png')"
                            :data="$store.getters.mqttVal(deviceName + '/' + 'CO2') || '--'" unit="μg/m³" />
                        <div class="bigChart">
                            <SingalLine :dataArr="pData.length > 0 ? pData : []"
                                :axisArr="paxisArr.length > 0 ? paxisArr : []" />
                        </div>
                    </div>
                </Box>
            </div>
            <div class="right">
                <MonitorItem v-for="(item,i) in monitorItems" :key="i" :icon="item.icon" :name="item.name"
                    v-show="$store.getters.mqttVal(deviceName + '/' + item.data) != 'undefined'" :title="item.title"
                    :data="$store.getters.mqttVal(deviceName + '/' + item.data)" :unit="item.unit" />
            </div>
        </div>
    </div>
</template>

<script>
    import Header from "../Header";
    import Box from "../Box";
    import SingalLine from "../../../chart/SingalLine";
    import MonitorItem from "../../../components/OperatingEnvironment/MonitorItem";
    import {
        connect,
        subscribeEnvironmentInfo,
        unsubscribeEnvironmentInfo
    } from '../../../mqtt/index'
    import {
        GetSensor,
        GET_AREAS,
        LOOP_DIAGRAM_DATA_BY_DAY,
    } from '../../../api/common'

    export default {
        name: "EnvironmentalMonitoring",
        components: {
            Header,
            Box,
            SingalLine,
            MonitorItem
        },
        data() {
            return {
                areaId: -1,
                loopId: 1,
                deviceName: '',


                tData: [],
                taxisArr: [],
                hData: [],
                haxisArr: [],
                pData: [],
                paxisArr: [],

                monitorItems: [{
                    icon: '',
                    name: 'TVOC',
                    title: 'TVOC监测',
                    data: 'TVOC',
                    unit: 'μg/m³',
                }, {
                    icon: '',
                    name: '甲醛',
                    title: '甲醛监测',
                    data: 'CH2O',
                    unit: 'μg/m³',
                }, {
                    icon: '',
                    name: 'PM1',
                    title: 'PM1监测',
                    data: 'PM1.0',
                    unit: 'μg/m³',
                }, {
                    icon: '',
                    name: 'PM2.5',
                    title: 'PM2.5监测',
                    data: 'PM2.5',
                    unit: 'μg/m³',
                }, {
                    icon: '',
                    name: 'PM10',
                    title: 'PM10监测',
                    data: 'PM10',
                    unit: 'μg/m³',
                }, {
                    icon: '',
                    name: '光照',
                    title: '光照强度监测',
                    data: 'Lux',
                    unit: 'Lux',
                }],

                axis: ['0点', '1点', '2点', '3点', '4点', '5点', '6点', '7点', '8点', '9点', '10点', '11点', '12点', '13点', '14点',
                    '15点', '16点', '17点', '18点', '19点', '20点', '21点', '22点', '23点', '24点'
                ]
            }
        },
        created() {
            connect()
            GET_AREAS().then(res => {
                this.areaId = res.data.data.areas[0].areaId
                this.getSensorData()
            })
        },
        beforeDestroy() {
            unsubscribeEnvironmentInfo(this.deviceName)
        },
        methods: {
            getCharData() {
                let tdataArr = []
                // let taxisArr = []
                let hdataArr = []
                // let haxisArr = []
                let pdataArr = []
                // let paxisArr = []
                this.taxisArr = this.axis
                this.haxisArr = this.axis
                this.paxisArr = this.axis
                LOOP_DIAGRAM_DATA_BY_DAY(this.loopId, 'Temperature_1h', new Date()).then(res => {
                    if (res.data.data.points.length > 0) {
                        res.data.data.points.map((item) => {
                            // tdataArr.push(parseFloat(item.val).toFixed(2))
                            let now = new Date(item.time).getHours()
                            tdataArr[now] = parseFloat(item.val).toFixed(2)
                            // let now = new Date(item.time).toLocaleTimeString('chinese', {
                            //     hour12: false
                            // }).replace(/^\D*/, '')
                            // let num = now.indexOf(':')
                            // taxisArr.push(now.substring(0, num) + "点")
                        })
                        this.tData = tdataArr
                    } else {
                        this.tData = []
                    }
                })
                LOOP_DIAGRAM_DATA_BY_DAY(this.loopId, 'Humidity_1h', new Date()).then(res => {
                    if (res.data.data.points.length > 0) {
                        res.data.data.points.map((item) => {
                            // hdataArr.push(parseFloat(item.val).toFixed(2))
                            let now = new Date(item.time).getHours()
                            hdataArr[now] = parseFloat(item.val).toFixed(2)
                            // haxisArr.push(now + "点")
                            // let now = new Date(item.time).toLocaleTimeString('chinese', {
                            //     hour12: false
                            // }).replace(/^\D*/, '')
                            // let num = now.indexOf(':')
                            // haxisArr.push(now.substring(0, num) + "点")
                        })
                        this.hData = hdataArr
                    } else {
                        this.hData = []
                    }
                })
                LOOP_DIAGRAM_DATA_BY_DAY(this.loopId, 'CO2_1h', new Date()).then(res => {
                    if (res.data.data.points.length > 0) {
                        res.data.data.points.map((item) => {
                            // pdataArr.push(parseFloat(item.val).toFixed(2))
                            let now = new Date(item.time).getHours()
                            pdataArr[now] = parseFloat(item.val).toFixed(2)
                            // paxisArr.push(now + "点")
                            // let now = new Date(item.time).toLocaleTimeString('chinese', {
                            //     hour12: false
                            // }).replace(/^\D*/, '')
                            // let num = now.indexOf(':')
                            // paxisArr.push(now.substring(0, num) + "点")
                        })
                        this.pData = pdataArr
                    } else {
                        this.pData = []
                    }
                })
            },
            getSensorData() {
                GetSensor(this.areaId).then(res => {
                    if (res.data.data.loop) {
                        this.loopId = res.data.data.loop.loopId
                        this.deviceName = res.data.data.loop.subLoopUrl
                        this.getCharData()
                        subscribeEnvironmentInfo(this.deviceName)
                    } else {
                        this.loopId = 1
                        this.deviceName = ''
                        this.getCharData()
                        subscribeEnvironmentInfo(this.deviceName)
                    }
                })
            },
            changeSite(value) {
                this.areaId = value
                this.getSensorData()
            }
        }
    };
</script>

<style lang="less" scoped>
    .content {
        .w(1600);
        .h(968);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .body {
        width: 100%;
        .h(864);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .left {
            .w(1198);
            .h(864);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            .itemContainer {
                margin-top: 200/108vh;
            }

            .box {
                display: flex;
                justify-content: flex-start;
            }
        }

        .right {
            .w(394);
            .h(864);
            background: #FFFFFF;
            box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
            padding-left: 950/192vw;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: flex-start;
        }
    }

    .smallChart {
        .w(529);
        .h(211);
        margin-top: 450/108vh;
    }

    .bigChart {
        .w(1177);
        .h(230);
        margin-top: 180/108vh;
    }
</style>